import { atom } from "recoil"

export const teamPermissionRequestIdState = atom<number>({
  key: "atoms/organization/teamPermissionRequestIdState",
  default: 0,
})
